/* eslint-disable react/prop-types */
import { MultiSelect, Radio, TextField } from '@tmov/design-system';
import { SpinnerMedium } from '@tmov/design-system/icons';
import { DatePicker, Form, TimePicker } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { LoadingContainer } from '../../../../components/LoadingContainer';
import NumberFormat from '../../../../components/NumberFormat';
import TipoPagamentoEnum from '../../../../Enum/TipoPagamentoEnum';
import {
  formatarCnpjCpfIMask,
  toTitleCase,
} from '../../../../helpers/formatador';
import { getTransportadoras } from '../../../../helpers/transportadoras';
import { useAuth } from '../../../../security/authContext';
import apiShipper from '../../../../services/apiShipper';
import FormSection from '../FormSection';
import { SectionInputsRow } from '../FormSection/styles';

const pagamentoOptions = TipoPagamentoEnum.getValues().map(tipoPagamento => ({
  id: tipoPagamento.value.toString(),
  name: tipoPagamento.label,
}));

function Cotacao() {
  const { user } = useAuth();

  const [transportadorasOptions, setTransportadorasOptions] = useState([]);

  const validateTransportadoras = (_, value) => {
    if (value.find(option => option.checked)) {
      return Promise.resolve();
    }

    return Promise.reject(new Error('Selecione pelo menos uma Transportadora'));
  };

  const validateNumber = (_, value) => {
    if (/^\d*,?\d+$/.test(value)) {
      return Promise.resolve();
    }

    return Promise.reject(new Error('Selecione um valor numérico'));
  };
  const validatePeriodo = async (value, getFieldValue) => {
    if (!value) {
      return Promise.reject(new Error('Insira uma data'));
    }

    const inicio = getFieldValue('dataInicioCotacao');
    const fim = getFieldValue('dataFimCotacao');

    if (inicio && fim && inicio.isAfter(fim)) {
      return Promise.reject(
        new Error('A data de início da cotação deve ser menor que a data fim ')
      );
    }
    return Promise.resolve();
  };

  useEffect(() => {
    const getDadosTransportadora = async () => {
      const { data } = await apiShipper.get('/empresas-parceiras');

      const transportadoras = await getTransportadoras(
        user,
        data.empresas_tmov_id
      );

      if (transportadoras) {
        setTransportadorasOptions(
          transportadoras.map(transportadora => ({
            id: transportadora.id,
            label: `${toTitleCase(
              transportadora.razaoSocial
            )} - ${formatarCnpjCpfIMask(transportadora.cnpj)}`,
            checked: false,
          }))
        );
      }
    };
    getDadosTransportadora();
  }, [user]);

  return (
    <>
      <FormSection
        name="Participantes"
        description="Notificaremos os participantes selecionados sobre a cotação."
      >
        {transportadorasOptions.length !== 0 ? (
          <Form.Item
            name="transportadoras"
            valuePropName="options"
            initialValue={transportadorasOptions}
            rules={[{ validator: validateTransportadoras }]}
            wrapperCol={{ style: { gap: 12 } }}
          >
            <MultiSelect
              data-testid="multi-select-transportadoras"
              label={`Selecionar Transportadoras (${transportadorasOptions.length} opções)`}
              style={{ width: 476 }}
            />
          </Form.Item>
        ) : (
          <LoadingContainer height="10px">
            <SpinnerMedium />
          </LoadingContainer>
        )}
      </FormSection>
      <FormSection
        name="Pagamento"
        description="Especifique o tipo de pagamento da cotação."
      >
        <Form.Item
          name="tipoPagamento"
          initialValue="1"
          valuePropName="selectedOptionId"
        >
          <Radio options={pagamentoOptions} />
        </Form.Item>
      </FormSection>
      <FormSection name="Preferências" isLast>
        <SectionInputsRow>
          <Form.Item
            name="incrementoMin"
            initialValue=""
            rules={[{ validator: validateNumber }]}
          >
            <NumberFormat name="incrementoMin" label="Incremento mínimo" />
          </Form.Item>
          <Form.Item name="valorInicial" initialValue="">
            <NumberFormat name="valorInicial" label="Valor inicial" />
          </Form.Item>
        </SectionInputsRow>
        <SectionInputsRow>
          <Form.Item
            name="dataInicioCotacao"
            rules={[
              ({ getFieldValue }) => ({
                validator: (_, value) => validatePeriodo(value, getFieldValue),
              }),
            ]}
          >
            <DatePicker
              data-testid="data-inicio-cotacao"
              placeholder="Data do início da cotação"
              format="DD/MM/YYYY"
              disabledDate={d => !d || d.isBefore(moment().add(-1, 'days'))}
              style={{ width: 250 }}
            />
          </Form.Item>
          <Form.Item
            name="horarioInicioCotacao"
            rules={[
              {
                required: true,
                message: 'Insira um horário',
              },
            ]}
          >
            <TimePicker
              data-testid="horario-inicio-cotacao"
              placeholder="Horário do início da cotação"
              format="HH:mm"
              style={{ width: 250 }}
            />
          </Form.Item>
        </SectionInputsRow>
        <SectionInputsRow>
          <Form.Item
            name="dataFimCotacao"
            rules={[
              ({ getFieldValue }) => ({
                validator: (_, value) => validatePeriodo(value, getFieldValue),
              }),
            ]}
          >
            <DatePicker
              data-testid="data-fim-cotacao"
              placeholder="Data do fim da cotação"
              format="DD/MM/YYYY"
              disabledDate={d => !d || d.isBefore(moment().add(-1, 'days'))}
              style={{ width: 250 }}
            />
          </Form.Item>
          <Form.Item
            name="horarioFimCotacao"
            rules={[{ required: true, message: 'Insira um horário' }]}
          >
            <TimePicker
              data-testid="horario-fim-cotacao"
              placeholder="Horário do fim da cotação"
              format="HH:mm"
              style={{ width: 250 }}
            />
          </Form.Item>
        </SectionInputsRow>
        <Form.Item name="observacao">
          <TextField
            name="observacao"
            label="Observações"
            multiline
            style={{ width: 525 }}
          />
        </Form.Item>
      </FormSection>
    </>
  );
}

export default Cotacao;
